import { useEffect, useMemo, useState } from "react";
import { Button, Col, Container, Dropdown, DropdownButton, Form, Row } from "react-bootstrap";
import styles from "./addStaff.module.scss";
// img
import { generatePath, useNavigate, useParams } from "react-router-dom";
import KhanReportLogo from "components/shared/ReportComponents/KhanReortLogo";
import { useGetFeedbackStepDetailQuery, useSubmitFeedbackStepMutation } from "store/services/clients/assessmentTreatmentPlan";
import { formatReportFeedback, reportInitialValues } from "helpers/assessment";
import { object } from "yup";
import { reportQuestionsValidationSchema } from "utils/validation/validationHelpers";
import { CLIENT_REPORTS_LIST, DISCHARGE_SCREENING_REPORT_PREVIEW, SCHOOL_CLIENT_DETAIL, SCHOOL_CLIENT_LIST } from "config/paths";
import { FieldArray, Formik } from "formik";
import { CalendarIcon } from "Assets/icons";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { dateFormat, errorMessageToast, getAge, getPdfBlob, ReportsNoRecordMessage, successMessageToast, userFullName } from "helpers/common";
import { RenderQuestionById } from "components/shared/ReportComponents/Questions/Index";
import { CLIENT_REPORT_TYPES, DISCHARGE_SCREENING_REPORT_QUESTIONS, DISCIPLINE_REPORT_NAME_MAPPING, dobFormat, MIME_TYPES, REPORT_IDS, reportDateFormat } from "config/constants";
import AttachDocumentsReports from "components/shared/ReportComponents/AttachDocumentsReports";
import TherapistSignature from "components/shared/ReportComponents/TherapistSignature";
import LoadingButton from "components/shared/LoadingButton";
import GuardianDetailRow from "components/shared/ReportComponents/GuardianDetailRow";
import ReportHeader from "components/shared/ReportComponents/ReportHeader/Index";
import moment from "moment";
import ReportError from "components/shared/ReportsV2/ReportError";
import GuardianDetailList from "components/shared/ReportsV2/GuardianDetailsList";
import { AppSelect2Field } from "components/shared/FormComponents/AppSelect2Field";
import { useGetDisciplineAreasQuery, useLazyGetFileUrlQuery, useUploadFileMutation } from "store/services/utility";
import CKEditorField from "components/CkEditor/CkEditor";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { useCopyReportsMutation, useGetReportClientsAssessmentFeedbackQuery, useSubmitSchoolDischargeScreeningReportMutation } from "store/services/clients/reports-v2/schoolReports";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import PDFDocViewer from "components/PDF/PDFDocViewer";
import { DischargeScreeningPdfDocV2 } from "components/PDF/Clients/ReportsV2/DischargeScreeningPdfV2";
import { useSelector } from "react-redux";
import { schoolDischargeScreeningValidationSchema } from "./validation";
import ViewPdfModal from "components/Modals/ViewPdfModal";
import arro_right_img from "../../../../../../Assets/images/arrow-right.png"
import preview_img from "../../../../../../Assets/images/preview-btn.png"
import threDots_img from "../../../../../../Assets/images/three-dots.png"
import date_img from "../../../../../../Assets/images/date.png"
import AppSelectField from "components/shared/FormComponents/AppSelectField";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import AppFileUploadNestedField from "components/shared/FormComponents/AppFileUploadNestedField.jsx";
import { cloneDeep } from "lodash";
import ViewAttachments from "pages/SideTabPages/ManageStaff/StartSession/ViewAttachments";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import PdfPublishModal from "components/Modals/PdfPublishModal";
import { NoRecordFound } from "components/Common/Common";
import ClassroomReportDateModal from "components/Modals/ClassroomReportDateModalV2";
import confirmDialogV2 from "utils/confirmationDialogV2";

const SchoolDischargeScreeningReport = () => {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [previewMode, setPreviewMode] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const [pdfModal, setPdfModal] = useState(false)
  const [publishPdfModal, setPublishPdfModal] = useState(false)
  const [copyReportDateModal, setCopyReportDateModal] = useState(false)
  const [currentEntry, setCurrentEntry] = useState(null)


  const [document, setDocument] = useState(null)
  const { assessmentId, clientId, reportId } = useParams();
  const clientType = "school"
  const [reportHeading, setReportHeading] = useState(CLIENT_REPORT_TYPES[REPORT_IDS.DISCHARGE_SCREENING_REPORT].title);

  const [submitReport, { isLoading: submitReportLoading }] = useSubmitSchoolDischargeScreeningReportMutation()
  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();
  const [copyReport, { isLoading: copyReportLoading }] = useCopyReportsMutation()
  const { data, isLoading, isFetching, isError, refetch } = useGetReportClientsAssessmentFeedbackQuery({ reportId: 9, clientId, submittedReportId: reportId });
  const assessmentAssignedId = data?.assesment?.id;
  const caseDiscipline = data?.clientPendingCaseload?.clientCaseloadTherapist?.caseDiscipline;
  const caseTherapist = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "veteran")?.caseTherapist;
  const caseApprentice = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "apprentice");
  const therapistDetails = { caseDiscipline, caseTherapist, discipline_id: data?.clientPendingCaseload?.clientCaseloadTherapist?.discipline_id }
  const assesmentData = data?.assesmentData
  const { data: disciplineAreas, isLoading: areasLoading, isFetching: areasFetching } = useGetDisciplineAreasQuery(therapistDetails?.discipline_id, { skip: !therapistDetails?.discipline_id });

  const disciplineAreaOptions =
    disciplineAreas?.length > 0
      ? disciplineAreas?.map(area => ({
        value: area.id,
        label: area.name
      }))
      : [];

  const [initialValues, setInitialValues] = useState({
    saveForLater: false,
    apprentice_id: "",
    screening_date: null,
    screening_results: [{
      discipline_id: therapistDetails?.discipline_id,
      area_description: `<p>${data?.firstname}'s skills in this area did not indicate a need for further assessments or interventions. No further follow up is needed at this time.</p>`,
      area: null,
      attachmentData: []
    }]
  })

  // console.log("initialValues", initialValues)

  const therapist = useSelector((state) => state?.auth?.user)

  const handleSubmitStep = async (values) => {
    setSubmitting(true);

    try {
      const reportAreas = values?.screening_results?.map((item) => ({ discipline_id: item?.discipline_id, area_id: item?.area?.value, area_description: item?.area_description, attachmentData: item?.attachmentData, id: item?.id ? item?.id : null }))


      let body = {}


      if (therapist?.role_type == "apprentice" || values?.saveForLater) {
        body = {
          signatureBy: values?.apprentice_id,
          reportAreas,
          assesment_location: "in-person",
          feedbacks: [],
          screening_date: values?.screening_date,
          report_heading: reportHeading,
          save_for_later: "yes",
          guardianList: values?.guardianList,
        }
      }
      else {

        const selectedGuardians = data?.client_detail?.client_guardian_mapping?.length > 0 &&
          [...data.client_detail.client_guardian_mapping]
            .map((guardian) => {
              const id = guardian?.client_guardian?.id;
              const role = guardian?.client_guardian?.client_role?.title;

              const matchedGuardian = values?.guardianList?.find(
                (item) => item.id === id
              );

              if (matchedGuardian) {
                return {
                  ...guardian,
                  key: matchedGuardian?.role  // or matchedGuardian.role
                };
              }

              return null;
            })
            .filter(Boolean);

        const pdfData = {
          lastname: data?.lastname,
          firstname: data?.firstname,
          city_town: data?.client_detail?.city_town,
          dob: dateFormat(data?.client_detail?.dob, dobFormat),
          age: getAge(data?.client_detail?.dob),
          grade: data?.client_detail?.grade,
          reportAreas: values?.screening_results,
          schoolName: data?.client_detail?.client_school_detail?.client_school?.name,
          schoolLocation: data?.client_detail?.client_school_detail?.client_school?.location,
          screening_date: moment(values?.screening_date).format("MMMM D, YYYY"),
          selectedGuardians,
          reportHeading,
          therapist,
          apprentice: values?.apprentice_id,
          caseApprentice,
          therapistSignature: therapist?.signature_img,
          emailSignature: therapist?.email_signature,
          reportDate: moment(new Date()).format("MMMM D, YYYY"),
        }

        const doc = (
          <DischargeScreeningPdfDocV2
            data={pdfData}
          />
        )

        // setDocument(doc)

        const filename = `Discharge Screening Report - ${caseDiscipline?.assign_term} - ${moment(new Date()).format("YYYY-MM-DD")}.pdf`
        let pdfFile = await getPdfBlob(doc, false, filename);

        let uploadedFileName = await uploadFile({ file: pdfFile, acl: "private", fileOriginalFormat: true }).unwrap();

        if (!uploadedFileName) {
          throw new Error("File not uploaded");
        };


        body = {
          signatureBy: values?.apprentice_id,
          reportAreas,
          assesment_location: "in-person",
          feedbacks: [],
          screening_date: values?.screening_date,
          report_heading: reportHeading,
          guardianList: values?.guardianList,
          pdfData: [{
            attachment_key: uploadedFileName,
            attachment_name: CLIENT_REPORT_TYPES[assessmentId].name,
          }],
          emailFormData: values?.emailFormData,
          current_step: "submit_and_email",
        }
      }

      const response = await submitReport({ data: body, clientId: assessmentAssignedId }).unwrap()
      refetch()
      successMessageToast(response.message)
      setSubmitting(false);
      if (!values?.saveForLater) {
        navigate(SCHOOL_CLIENT_DETAIL.replace(":id", clientId))
      }
    } catch (error) {
      setSubmitting(false);
      console.log('error', error)
    }
  };

  const handleViewPdf = (values) => {
    const selectedGuardians = data?.client_detail?.client_guardian_mapping?.length > 0 &&
      [...data.client_detail.client_guardian_mapping]
        .map((guardian) => {
          const id = guardian?.client_guardian?.id;
          const role = guardian?.client_guardian?.client_role?.title;

          const matchedGuardian = values?.guardianList?.find(
            (item) => item.id === id
          );

          if (matchedGuardian) {
            return {
              ...guardian,
              key: matchedGuardian?.role  // or matchedGuardian.role
            };
          }

          return null;
        })
        .filter(Boolean);

    const pdfData = {
      lastname: data?.lastname,
      firstname: data?.firstname,
      city_town: data?.client_detail?.city_town,
      dob: dateFormat(data?.client_detail?.dob, dobFormat),
      age: getAge(data?.client_detail?.dob),
      grade: data?.client_detail?.grade,
      reportAreas: values?.screening_results,
      schoolName: data?.client_detail?.client_school_detail?.client_school?.name,
      schoolLocation: data?.client_detail?.client_school_detail?.client_school?.location,
      screening_date: moment(values?.screening_date).format("MMMM D, YYYY"),
      selectedGuardians,
      reportHeading,
      therapist,
      apprentice: values?.apprentice_id,
      caseApprentice,
      therapistSignature: therapist?.signature_img,
      emailSignature: therapist?.email_signature,
      reportDate: moment(new Date()).format("MMMM D, YYYY"),
    }

    const doc = (
      <DischargeScreeningPdfDocV2
        data={pdfData}
      />
    ) 

    setDocument(doc)
    setPdfModal(true)

  };

  const handleCopyReportApi = async (reportId, assessmentId, screening_date) => {
    const reportType = CLIENT_REPORT_TYPES[assessmentId]?.copyType
    console.log('assessmentId for reort ', assessmentId)
    try {
      await copyReport({ clientId, clientType, reportId, reportType, assessmentId, screening_date }).unwrap()
      if (copyReportDateModal) {
        setCopyReportDateModal(false)
      }
      navigate(generatePath(CLIENT_REPORTS_LIST, { clientId, clientType }))
    } catch (error) {
      console.log('error copying report:', error)
    }
  }
  const handleCopyReport = async (e, reportId, assessmentId) => {
    e.stopPropagation();
    const isConfirm = await confirmDialogV2({
      title: "MAKE A COPY",
      message: `A copy of this report will be added to your list with ${moment().format(reportDateFormat)} as the Report Date.`,
    });
    if (!isConfirm) {
      setCopyReportDateModal(true)
      return
    }
    else {
      handleCopyReportApi(reportId, assessmentId, moment(new Date()).format("YYYY-MM-DD"))
    }
  }

  useEffect(() => {
    if (data || disciplineAreas) {
      const guardianList = data?.assesment?.AssesmentGuardianAssigned?.map((item) => ({ id: item?.AssessmentReportGuardians?.id, role: item?.role }))
      const [year, month, day] = data?.client_detail?.dob ? data?.client_detail?.dob.split("-") : "";
      const formattedDob = `${day}${month}${year}`;
      const password = `${data?.firstname}${data?.lastname}${formattedDob}`
      setInitialValues((prev) => ({
        ...prev,
        screening_results: assesmentData?.reportAreas?.length ? assesmentData?.reportAreas?.map((item) => ({
          discipline_id: item?.discipline_id,
          area_description: item?.area_description,
          area: disciplineAreaOptions?.find((x) => x?.value == item?.area_id),
          attachmentData: item?.attachmentData == "null" ? [] : item?.attachmentData ? JSON.parse(item?.attachmentData) : [],
          id: item?.id
        })) : [{
          discipline_id: therapistDetails?.discipline_id,
          area_description: `${data?.firstname}'s skills in this area did not indicate a need for further assessments or interventions. No further follow up is needed at this time.`,
          area: null,
          attachmentData: [],
          id: null
        }],
        screening_date: data?.assesment?.screening_date,
        apprentice_id: data?.assesment?.signatureBy,
        student: data?.assesment?.signatureBy ? { label: userFullName(caseApprentice?.caseTherapist), value: data?.assesment?.signatureBy } : null,
        guardianList,
        // emailFormData: {
        //   pdfPassword: password
        // }
      }))
    }

    // if (data?.assesment?.status == 'submitted') {
    //   setPreviewMode(true)
    // }

  }, [data, disciplineAreas])

  return (
    <>
      {copyReportLoading && <LoadingOverlay />}
      <ClassroomReportDateModal
        show={copyReportDateModal}
        setShow={setCopyReportDateModal}
        isLoading={copyReportLoading}
        currentEntry={currentEntry}
        handleCopyReportApi={handleCopyReportApi}
        type='school'
      />
      <section className="ReportSec schooldeschargeInput proxima container-discharge-screen py-3 position-relative">
        <Container fluid>
          <div style={{ maxWidth: "80%", margin: "0 auto" }}>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmitStep}
              validationSchema={schoolDischargeScreeningValidationSchema}
              enableReinitialize
            >
              {({ handleSubmit, values, errors, touched, setFieldValue, submitForm }) => (
                <Form onSubmit={handleSubmit}>
                  <ViewPdfModal publishPdfCheckbox={true} show={pdfModal} clientType={clientType} setShow={setPdfModal} doc={document} handleSubmit={submitForm} guardianList={data?.client_detail?.client_guardian_mapping} data={data} />
                  <PdfPublishModal publishPdfCheckbox={true} show={publishPdfModal} setShow={setPublishPdfModal} clientType={clientType} doc={document} handleSubmit={submitForm} guardianList={data?.client_detail?.client_guardian_mapping} />
                  {(isLoading || areasLoading) ? (
                    <LoadingIndicator />
                  ) : isError ? (
                    <ErrorComponent />
                  ) : (
                    <Row>
                      <Col lg="12" className="my-2">
                        <div className="bg-white">
                          <>
                            {(isFetching || submitting || areasFetching) && <LoadingOverlay />}
                            {/* <ReportHeader
                            initialHeading={data?.assesment?.report_heading || reportHeading}
                            therapistDetails={therapistDetails}
                            setHeading={setReportHeading}
                          /> */}

                            <div className="formBody al reports-v2">
                              <div className="d-flex justify-content-between">

                                <div>
                                  <h5 className="section-title mb-0 border-0" style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "1px" }}>Speech Language Pathology</h5>
                                  <p style={{ fontSize: "20px", marginTop: "5px", color: "#000" }}>Screening Discharge Report</p>
                                </div>
                                <div>
                                  <button
                                    onClick={(e) => { handleCopyReport(e, reportId, assessmentId); setCurrentEntry({ id: reportId, assesment_type: assessmentId }) }}
                                    type="button"
                                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                  // disabled={isFetching || submitting || copyReportLoading}
                                  // isLoading={submitReportLoading || submitting}
                                  >
                                    Make a Copy
                                  </button>
                                </div>
                              </div>
                              <div
                                className="mt-4 client-view"
                              // style={{ borderBottom: "2px dashed #6c6c6c" }}
                              >
                                {/* CLIENT INFORMATION */}



                                <h5 className="section-title">CLIENT INFORMATION</h5>
                                <div className="mb-3 d-flex align-items-center" style={{ gap: "20px" }}>
                                  <div style={{ width: "25%" }}>
                                    <label className="discharge-screen-label">Last Name</label>
                                    <input className="readonly-box" readOnly value={data?.lastname} />
                                  </div>
                                  <div style={{ width: "25%" }}>
                                    <label className="discharge-screen-label">First Name</label>
                                    <input className="readonly-box" readOnly value={data?.firstname} />
                                  </div>
                                  <div style={{ width: "30%" }}>
                                    <label className="discharge-screen-label">City/Town</label>
                                    <input className="readonly-box" readOnly value={data?.client_detail?.city_town} />
                                  </div>
                                  <div style={{ width: "20%" }}>
                                    <label className="discharge-screen-label">Date of Report</label>
                                    <div className="readonly-box d-flex align-items-center">
                                      <input style={{ outline: "none" }} className="border-0 w-100" readOnly value={moment().format("YYYY-MM-DD")} />
                                      <img width={14} height={16} src={date_img} alt="date_img" />
                                    </div>
                                  </div>
                                </div>
                                <div className="mb-4 d-flex align-items-center" style={{ gap: "20px" }}>
                                  <div style={{ width: "50%" }}>
                                  </div>
                                  <div style={{ width: "20%" }}>
                                    <label className="discharge-screen-label">Birth Date</label>
                                    <div className="readonly-box d-flex align-items-center">
                                      <input style={{ outline: "none" }} className="border-0 w-100" readOnly value={dateFormat(data?.client_detail?.dob, dobFormat)} />
                                      <img width={14} height={16} src={date_img} alt="date_img" />
                                    </div>
                                  </div>
                                  <div style={{ width: "15%" }}>
                                    <label className="discharge-screen-label">Age</label>
                                    <div className="mt-2 proxima">{getAge(data?.client_detail?.dob)}</div>
                                  </div>
                                  <div style={{ width: "10%" }}>
                                    <label className="discharge-screen-label">Grade</label>
                                    <input className="readonly-box normal-grade" readOnly value={data?.client_detail?.grade} />
                                  </div>
                                </div>
                                <h5 className="section-title mt-5">SCHOOL INFORMATION</h5>
                                <div className="mb-3 d-flex align-items-center" style={{ gap: "20px" }}>
                                  <div style={{ width: "33%" }}>
                                    <label className="discharge-screen-label">School Name</label>
                                    {/* <div className="readonly-box">{data?.client_detail?.client_school_detail?.client_school?.name}</div> */}
                                    <input className="readonly-box" readOnly value={data?.client_detail?.client_school_detail?.client_school?.name} />
                                  </div>
                                  <div style={{ width: "33%" }}>
                                    <label className="discharge-screen-label">City / Town</label>
                                    <input className="readonly-box" readOnly value={data?.client_detail?.client_school_detail?.client_school?.location} />
                                    {/* <div className="readonly-box">{data?.client_detail?.client_school_detail?.client_school?.location}</div> */}
                                  </div>
                                </div>
                                {data?.client_detail?.client_guardian_mapping?.[0]?.client_guardian ?
                                  [...data.client_detail.client_guardian_mapping] // clone the array
                                    .map((guardian, index) => {
                                      const slug = guardian?.client_guardian?.client_role?.slug;
                                      if (slug !== (clientType === "school" ? "teacher" : "parent")) {
                                        return null;
                                      }
                                      if ([0, 1].includes(index)) {
                                        return (
                                          <GuardianDetailList
                                            previewMode={previewMode}
                                            key={index}
                                            index={index}
                                            guardian={guardian}
                                            slug={slug}
                                            values={values}
                                          />
                                        );
                                      }
                                      else {
                                        return
                                      }
                                    }) : <ReportsNoRecordMessage msg="No teacher is currently assigned to this client." />
                                }

                                {/* <div className="reports-guardian-title">
                                <Col lg={12}>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex gap-2 align-items-center">
                                      <input
                                        type="checkbox"
                                        className=""
                                      // onChange={() => handleSelectClient(item?.id)}
                                      // checked={selectedClients === item?.id}
                                      />
                                      {/* <h6 className="m-0 fw-sbold">{item?.lastname || ""}</h6>  
                                      COORDINATOR
                                    </div>
                                    {/* <div className="d-flex gap-2 align-items-center">
                                      <input
                                        type="checkbox"
                                        className=""
                                      onChange={() => handleSelectClient(item?.id)}
                                      checked={selectedClients === item?.id}
                                      />
                                      <h6 className="m-0 fw-sbold">{item?.lastname || ""}</h6>
                                      {'COORDINATOR'} {"Present"}
                                    </div> 
                                  </div>
                                </Col>
                              </div> */}
                                {/* <Row className="mb-3 .reports-v2">
                                <Col md={3}>
                                  <label
                                    htmlFor=""
                                    className="form-label themeBlue fw-bold mb-0"
                                  >
                                    Last Name
                                  </label>
                                  <AppInputField
                                    name="coordinatorFirstName"
                                    fieldType="text"
                                    placeholder=""
                                    className={`${styles.formControl} ${styles.textarea} form-control`}
                                  />
                                </Col>
                                <Col md={3}>
                                  <label
                                    htmlFor=""
                                    className="form-label themeBlue fw-bold mb-0"
                                  >
                                    First Name
                                  </label>                               
                                  <AppInputField
                                    name="coordinatorLastName"
                                    fieldType="text"
                                    placeholder=""
                                    className={`${styles.formControl} ${styles.textarea} form-control`}
                                  />
                                </Col>
                                <Col md={3}>
                                  <label
                                    htmlFor=""
                                    className="form-label themeBlue fw-bold mb-0"
                                  >
                                    Email
                                  </label>                                 
                                  <AppInputField
                                    name="coordinatorEmail"
                                    fieldType="text"
                                    placeholder=""
                                    className={`${styles.formControl} ${styles.textarea} form-control`}
                                  />
                                </Col>
                              </Row> */}

                                <div className="py-2 reports-v2 position-relative">
                                  <Row className="justify-content-between mt-3">
                                    <Col lg="9">
                                      <h5 className="section-title mb-0">SCREENING RESULTS</h5>
                                    </Col>
                                    <Col lg="3">
                                      <div style={{ top: 30, right: 0 }} className="">
                                        <label className="mb-2 discharge-screen-label">Date of Screening</label>
                                        <AppDatePicker
                                          name="screening_date"
                                          className={`${styles.formControl} ${styles.textarea} form-control`}
                                          disabled={previewMode}
                                        />
                                      </div>
                                    </Col>
                                  </Row>

                                  <FieldArray name="screening_results">
                                    {({ push, remove, form }) => {
                                      const { values, setFieldValue } = form;

                                      return (
                                        <>
                                          {values?.screening_results?.map((_, index) => (
                                            <div key={index} className="py-2 reports-v2" style={{ marginTop: "-41px", width: "74%", gap: "110px" }}>
                                              {/* <div style={{ width: data?.assesment?.status != 'submitted' ? '100%' : '74%' }}> */}
                                              <div className="d-flex gap-2" style={{ marginBottom: "55px" }}>
                                                <label style={{ whiteSpace: "nowrap", marginTop: "11px" }} className="discharge-screen-label">{`Area ${index + 1}`}</label>
                                                <div className="w-100">
                                                  <div className="d-flex gap-2 align-items-center">
                                                    <div className="w-100">
                                                      <AppSelect2Field
                                                        isDisabled={previewMode}
                                                        name={`screening_results[${index}].area`}
                                                        placeholder="Select Area"
                                                        classNamePrefix="khan"
                                                        // style={{zIndex: 100}}
                                                        option={disciplineAreaOptions}
                                                        isLoading={areasLoading}
                                                        onChange={(selected) => {
                                                          setFieldValue(`screening_results[${index}].area`, selected);
                                                          // setFieldValue(`screening_results[${index}].goal_id`, null); // Example: reset goal_id
                                                        }}
                                                      />
                                                    </div>
                                                    {
                                                      !previewMode && <div className="cstm-dropdownclass">
                                                        <Dropdown>
                                                          <Dropdown.Toggle id="dropdown-basic">
                                                            <img width={19} height={18} src={threDots_img} alt="threDots_img" />
                                                          </Dropdown.Toggle>

                                                          <Dropdown.Menu>
                                                            <Dropdown.Item onClick={() => remove(index)}>Delete</Dropdown.Item>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </div>
                                                    }
                                                  </div>
                                                  <Col lg="12 py-3">
                                                    <div className="ck-editor-wrapper">
                                                      <CustomEditor previewMode={previewMode} name={`screening_results[${index}].area_description`} attachmentName={`screening_results[${index}].attachmentData`} />
                                                      {/* <CKEditorField
                                                            items={[
                                                              'bold',
                                                              'italic',
                                                              'underline',
                                                              'alignment',
                                                              '|',
                                                              'bulletedList',
                                                              'numberedList',
                                                              // 'outdent',
                                                              // 'indent',
                                                            ]}
                                                            value={values?.screening_results?.[index]?.area_description}
                                                            handleChange={(event, editor) => {
                                                              setFieldValue(`screening_results[${index}].area_description`, editor?.getData());
                                                            }}
                                                          /> */}
                                                    </div>
                                                    {/* {touched?.screening_results?.[index]?.area_description && errors?.screening_results?.[index]?.area_description && (
                                                      <div style={{ color: 'red', marginTop: 4 }}>{errors?.screening_results?.[index]?.area_description}</div>
                                                    )} */}
                                                  </Col>

                                                  {
                                                    console.log('formik VALUES ', values)
                                                  }
                                                  {/* {
                                                    !previewMode && <Col lg="6">
                                                      <AppFileUploadNestedField
                                                        disabled={previewMode}
                                                        name={`screening_results[${index}].attachmentData`}
                                                        acl={"public-read"}
                                                        accept="image/*, application/pdf, .doc, .docx"
                                                        allowedTypes={[MIME_TYPES.pdf, MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.jpg, MIME_TYPES.webp, MIME_TYPES.doc, MIME_TYPES.docx]}
                                                        className={`form-control`}
                                                        onChange={(name, value) => {
                                                          // Update the specific client's files array
                                                          const screening_results = [...values.screening_results];
                                                          console.log('screening_results', screening_results)
                                                          screening_results[index].attachmentData.push({
                                                            attachment_key: value,
                                                            attachment_name: value,
                                                          })
                                                          setFieldValue("screening_results", screening_results);
                                                        }}
                                                      />
                                                    </Col>
                                                  } */}

                                                  {/* <Col lg="12">
                                                    <ViewAttachments
                                                      viewButtonCss="preview-discharge-screen"
                                                      attachments={values?.screening_results?.[index].attachmentData}
                                                      handleViewPdf={handleViewAttachment}
                                                      title={"Attachments :"}
                                                    />
                                                  </Col> */}

                                                </div>
                                              </div>
                                            </div>
                                          ))}


                                          {
                                            !previewMode &&
                                            <button
                                              type="button"
                                              className="btn proxima-regular btn-primary"
                                              style={{
                                                fontSize: "16px",
                                                fontWeight: 500,
                                                borderRadius: 2,
                                                marginTop: "50px",
                                                backgroundColor: "#315D99",
                                                padding: '8px 22px',
                                                border: 0
                                              }}
                                              onClick={() =>
                                                push({
                                                  discipline_id: therapistDetails?.discipline_id,
                                                  area: '',
                                                  area_description: `${data?.firstname}'s skills in this area did not indicate a need for further assessments or interventions. No further follow up is needed at this time.`,
                                                  attachmentData: []
                                                })
                                              }
                                            >
                                              Add Another Area
                                            </button>
                                          }
                                        </>
                                      );
                                    }}
                                  </FieldArray>

                                </div>

                                {
                                  therapist?.role_type == "veteran" &&
                                  <>
                                    <div className="py-2 reports-v2" style={{ marginTop: "42px" }}>
                                      <h5 className="section-title mb-0">SIGNATURE</h5>
                                    </div>
                                    <div className="d-flex gap-2 mt-2 align-items-center">
                                      <input
                                        type="checkbox"
                                        className="form-check"
                                        style={{ accentColor: "#b46c9f", height: 20, width: 20 }}
                                        disabled={previewMode}
                                        onChange={(e) => {
                                          if (values?.student?.value) {
                                            setFieldValue('apprentice_id', e.target.checked ? caseApprentice?.therapist_id : null);
                                          }
                                          else {
                                            errorMessageToast("Please select the apprentice")
                                          }
                                        }}
                                        checked={values.apprentice_id === caseApprentice?.therapist_id}
                                      />
                                      <div className="d-flex student-cstm-select flex-1 w-100 gap-2 align-items-center">
                                        <span className="proxima" style={{ fontSize: "14px" }}>Add Student:</span>
                                        <Col md='4'>
                                          <AppSelect2Field
                                            name='student'
                                            option={caseApprentice?.therapist_id ? [{ label: userFullName(caseApprentice?.caseTherapist), value: caseApprentice?.therapist_id }] : []}
                                            placeholder="Select a student..."
                                            classNamePrefix="khan"
                                          />
                                        </Col>
                                      </div>
                                    </div>
                                  </>
                                }


                                {/* <div className="py-3">
                                <RenderQuestionById
                                  questionId={DISCHARGE_SCREENING_REPORT_QUESTIONS.screening_results}
                                  reportQuestions={reportQuestions}
                                  fieldData={screeningTemplateData}
                                />
                              </div>
                              <div className="py-3">
                                <RenderQuestionById
                                  questionId={DISCHARGE_SCREENING_REPORT_QUESTIONS.greeting}
                                  reportQuestions={reportQuestions}
                                  showQuestion={false}
                                />
                              </div> */}
                                {/* <div className="py-3">
                                <AttachDocumentsReports
                                  acl={"private"}
                                  name="documents"
                                  allowedTypes={["pdf", "doc", "docx", "jpg", "xlsx", "png"]}
                                />
                              </div> */}
                              </div>
                              <div className="">
                                {/* <div className="py-3">
                                <TherapistSignature
                                  therapistDetails={therapistDetails}
                                />
                              </div> */}
                                {/* <div className="py-3">
                                <KhanReportLogo />
                              </div> */}
                              </div>
                            </div>
                          </>
                        </div>
                      </Col>

                      <Col lg="12" className="my-4">
                        <ReportError />
                        <div className='d-flex gap-3 align-items-center justify-content-end'>
                          {/* {
                          previewMode ?
                            <Button
                              type="button"
                              className="d-flex align-items-center justify-content-center commonBtn"
                              // isLoading={submittingStep}
                              disabled={isFetching || submitting}
                              onClick={() => setPreviewMode(false)}
                            >
                              Edit
                            </Button> : <Button
                              type="button"
                              className="d-flex align-items-center justify-content-center commonBtn"
                              // isLoading={submittingStep}
                              disabled={isFetching || submitting}
                              onClick={() => setPreviewMode(true)}
                            >
                              Preview
                            </Button>
                        } */}
                          <button
                            type="button"
                            className="d-flex align-items-center gap-2 justify-content-center preview-discharge-screen"
                            // isLoading={submittingStep}
                            disabled={isFetching || submitting}
                            onClick={() => handleViewPdf(values)}
                          >
                            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M0 0.777778C0 0.571498 0.0842854 0.373667 0.234315 0.227806C0.384344 0.0819442 0.587827 0 0.8 0H15.2C15.4122 0 15.6157 0.0819442 15.7657 0.227806C15.9157 0.373667 16 0.571498 16 0.777778V13.2222C16 13.4285 15.9157 13.6263 15.7657 13.7722C15.6157 13.9181 15.4122 14 15.2 14H0.8C0.587827 14 0.384344 13.9181 0.234315 13.7722C0.0842854 13.6263 0 13.4285 0 13.2222V0.777778ZM1.6 1.55556V12.4444H14.4V1.55556H1.6ZM3.2 3.11111H4.8V4.66667H3.2V3.11111ZM4.8 6.22222H3.2V7.77778H4.8V6.22222ZM3.2 9.33333H4.8V10.8889H3.2V9.33333ZM12.8 3.11111H6.4V4.66667H12.8V3.11111ZM6.4 9.33333H12.8V10.8889H6.4V9.33333ZM12.8 6.22222H6.4V7.77778H12.8V6.22222Z" fill="white" />
                            </svg>

                            Preview
                          </button>
                          <>
                            <LoadingButton
                              onClick={() => setFieldValue('saveForLater', true)}
                              type="submit"
                              className="d-flex align-items-center justify-content-center save-discharge-screen"
                              disabled={previewMode || isFetching || submitting}
                            // isLoading={submitReportLoading || submitting}
                            >
                              Save
                            </LoadingButton>
                            {
                              therapist?.role_type == "veteran" &&
                              <LoadingButton
                                onClick={() => { setFieldValue('saveForLater', false); setPublishPdfModal(true) }}
                                type="button"
                                className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                disabled={previewMode || isFetching || submitting}
                              // isLoading={submitReportLoading || submitting}
                              >
                                SUBMIT & Export
                                <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M9.68197 3.24568L8.85675 0.5H10.2193L14 4.29259V4.70741L10.2193 8.5H8.85675L9.68197 5.75432H0V3.24568H9.68197Z" fill="white" />
                                </svg>
                              </LoadingButton>
                            }
                          </>
                        </div>
                      </Col>

                    </Row>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </Container>
      </section>
    </>
  );
};

export default SchoolDischargeScreeningReport;